import { Dispatch } from 'redux';
import { ApiJob } from '../http/api-job';
import { jobActions } from '../slices/job-slice';

const {
  getCurrentPositionRequest,
  getCurrentPositionSuccess,
  getCurrentPositionFailure,

  getPositionHistoryRequest,
  getPositionHistorySuccess,
  getPositionHistoryFailure,
} = jobActions;

export const forceGetCurrentPosition =
  (pinfl: string | number) => async (dispatch: Dispatch<any>) => {
    dispatch(getCurrentPositionRequest());
    try {
      const data = await ApiJob.currentPosition(pinfl);
      dispatch(getCurrentPositionSuccess({ pinfl, data }));
    } catch (error) {
      dispatch(getCurrentPositionFailure(error));
    }
  };

export const getCurrentPosition =
  (pinfl: string | number) => async (dispatch: Dispatch<any>, getState: any) => {
    const storeStates = getState();
    const { list } = storeStates.job;
    if (!list || !list[pinfl]) {
      dispatch(forceGetCurrentPosition(pinfl));
    }
  };

export const getPositionHistory = (pinfl: string | number) => async (dispatch: Dispatch<any>) => {
  dispatch(getPositionHistoryRequest());
  try {
    const response: any = await ApiJob.positionHistory(pinfl);
    const data = response.data;
    dispatch(getPositionHistorySuccess({ pinfl, data }));
  } catch (error) {
    dispatch(getPositionHistoryFailure(error));
  }
};
